import React from 'react';

const PortfolioDetailsContent = ({title, category, description, meta}) => {
    return (
        <div className="portfolio-details-content">

            <a href="/" className="category">{category}</a>

            <h1 className="title">{title}</h1>

            <p>{description}</p>

            <ul className="project-info">
                {meta && meta.map((item, index) => (
                    <li key={index}>
                        <span>{item.label}:</span>{' '}
                        {item.isLink ? (
                            <a href={item.value} target="_blank" rel="noopener noreferrer" className="project-link"> {item.value}</a>
                        ) : (
                            item.value
                        )}
                    </li>
                ))}
            </ul>

            {/* <div className="project-share">
                <span>Share:</span>
                <a href="/"><i className="fa fa-facebook"/></a>
                <a href="/"><i className="fa fa-twitter"/></a>
                <a href="/"><i className="fa fa-pinterest-p"/></a>
                <a href="/"><i className="fa fa-google-plus"/></a>
            </div> */}

        </div>
    );
};

export default PortfolioDetailsContent;